import React, {Component} from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';
import config from '../../../config/config';
import axios from 'axios';
import Popover from "react-awesome-popover";
import JSONPretty from 'react-json-pretty';
import EventBus from "../../../helpers/EventBus";

class SupporterEventsBlock extends Component {
    state = {
        events: [],
        loading: true
    };

    componentDidMount() {
        this.loadData();
        EventBus.on('SupporterEventsBlock-load', this.loadData);
    }

    componentWillUnmount() {
        EventBus.remove('SupporterEventsBlock-load', this.loadData);
    }

    loadData = () => {
        let that = this;
        axios(config.server.endpoint + 'backend/supporter/events/' + this.props.supporterId, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    events: response.data,
                    loading: false
                })
            }
        });
    }

    render() {
        let {t} = this.props;
        return (
            <div className="ibox SupporterEventsBlock">
                <div className="ibox-title">
                    <h5>{t('supporterScreen.events.title')}</h5>
                </div>
                <div className="ibox-content">
                    {this.state.loading ? (
                        <div className="text-center">
                            <i className="fa fa-3x fa-spin fa-spinner"/>
                        </div>
                    ) : (
                        <table className="table">
                            <thead>
                            <tr>
                                <th>
                                    {t('supporterScreen.events.table.date')}
                                </th>
                                <th>
                                    {t('supporterScreen.events.table.user')}
                                </th>
                                <th>
                                    {t('supporterScreen.events.table.message')}
                                </th>
                                <th/>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.events.map((event, eKey) => (
                                <tr key={eKey}>
                                    <td>
                                        {moment(event.createdAt).format('DD.MM.YYYY HH:mm:ss')}
                                    </td>
                                    <td>
                                        {event.createdBy}
                                    </td>
                                    <td>
                                        {event.message}
                                    </td>
                                    <td>
                                        {event.details ? (
                                            <Popover targetClass="" contentClass="rap-popover-content">
                                                <button ref="target"
                                                        className="btn btn-default btn-xs btn-outline">
                                                    <i className="fa fa-info"/>
                                                </button>
                                                <div className="p-md">
                                                    <JSONPretty data={event.details}/>
                                                </div>
                                            </Popover>
                                        ) : null}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        )
    }
}

export default translate()(SupporterEventsBlock);
